import type { DocumentImportReviewRequestPayload } from './documentImportReviewTypes.js';

export interface ReviewOriginalRecoveryRequirement {
  required: boolean;
  deferred: boolean;
  expectedPages: number | null;
}

export function reviewOriginalRecoveryRequirement(
  payload: DocumentImportReviewRequestPayload,
  historicalPageCount: number | null,
): ReviewOriginalRecoveryRequirement {
  const deferred = payload.review_original_deferred?.status === 'pending';
  const expectedPages = payload.review_original_deferred?.expected_pages ?? historicalPageCount;
  if (deferred) return { required: false, deferred: true, expectedPages };
  if (payload.review_original_path) return { required: false, deferred: false, expectedPages };
  if (historicalPageCount != null && historicalPageCount > 1) {
    return { required: true, deferred: false, expectedPages: historicalPageCount };
  }
  const hasLegacySinglePageSource = Boolean(payload.image_b64 || payload.image_storage_path);
  return {
    required: !hasLegacySinglePageSource,
    deferred: false,
    expectedPages: historicalPageCount,
  };
}
